// Listen to Dom change, and add "Sendle" to OCTOLIZE SHIPPING COST CAL panel.
// 等待页面加载后执行
// 改成监听通用 class
const targetNode = document.querySelector('.shopify-app-block[id*="shipping_calculator"]');

if (targetNode) {
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          $(node).find(".oct-shipping-rate__title").addBack(".oct-shipping-rate__title").each(function() {
            if ($(this).text().trim() === "Domestic" && !$(this).hasClass("sendle-added")) {
              $(this).text("Sendle Domestic").addClass("sendle-added");
            }
          });
        }
      });
    });
  });

  observer.observe(targetNode, config);
}




// ------------------------------
// Global Toast Function
// ------------------------------
// ------------------------------
// 全局 Toast（亮黄 + 👍 图标）
// ------------------------------
// 全局 Toast：任何地方都可以 showToast('任意文案')
window.showToast = function(message, duration = 2500) {
  const toast = document.createElement('div');

  toast.style.position = 'fixed';
  toast.style.left = '50%';
  toast.style.top = '20px';
  toast.style.transform = 'translateX(-50%) translateY(-20px)';
  toast.style.display = 'flex';
  toast.style.alignItems = 'center';
  toast.style.background = '#FFEB3B';
  toast.style.border = '1px solid #E0C300';
  toast.style.color = '#000';
  toast.style.padding = '10px 18px';
  toast.style.borderRadius = '10px';
  toast.style.boxShadow = '0 4px 14px rgba(0,0,0,0.25)';
  toast.style.fontSize = '16px';
  toast.style.fontWeight = '600';
  toast.style.opacity = '0';
  toast.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
  toast.style.zIndex = '999999';

  // ⭐ 响应式：手机端宽度 80vw
  if (window.innerWidth < 768) {
    toast.style.width = '90vw';     // 手机端宽度
    toast.style.boxSizing = 'border-box';
    toast.style.justifyContent = 'center';
  }

  // 左侧图标
  const iconBox = document.createElement('span');
  iconBox.textContent = '👍';
  iconBox.style.background = '#FFF8A6';
  iconBox.style.padding = '6px 10px';
  iconBox.style.marginRight = '10px';
  iconBox.style.borderRadius = '6px';
  iconBox.style.fontSize = '17px';

  const text = document.createElement('span');
  text.textContent = message;

  toast.appendChild(iconBox);
  toast.appendChild(text);
  document.body.appendChild(toast);

  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
  });

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(-50%) translateY(-20px)';
    setTimeout(() => toast.remove(), 300);
  }, duration);
};



// ------------------------------
// 2️⃣ 页面加载时，检测是否要自动弹 toast（通过 sessionStorage）
// ------------------------------
document.addEventListener('DOMContentLoaded', function () {
  try {
    const msg = window.sessionStorage.getItem('toastMessage');
    if (msg) {
      window.sessionStorage.removeItem('toastMessage');
      window.showToast(msg);
    }
  } catch (e) {
    console.error(e);
  }
});


 
// ------------------------------
//3️⃣ 通用加车函数：前端传 variantId + message，无需写逻辑e
window.addToCartAndReloadWithToast = function(variantId, message) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: Number(variantId), quantity: 1 })
  })
  .then(function () {
    try {
      // 这里不写死文案，完全用调用方传进来的 message
      window.sessionStorage.setItem('toastMessage', message);
    } catch (e) {
      console.error(e);
    }
    window.location.reload();
  })
  .catch(function (err) {
    console.error(err);
    // 失败兜底：直接跳到购物车，这样至少用户能看到结果
    window.location.href = '/cart';
  });
};


// 4）取消CUSTOM ADD A FREEBIE, 改用APP。
// document.addEventListener('click', function(e) {
//   const btn = e.target.closest('#freebie-cta');
//   if (!btn) return;

//   e.preventDefault();

//   const variantId = btn.dataset.variantId;
//   const message = btn.dataset.toast || 'Freebie added';

//   window.addToCartAndReloadWithToast(variantId, message);
// });

// ////////////////
